const haveIcon = [
  '$PAC',
  '1st',
  'ABT',
  'ABYSS',
  'ACT',
  'ACTN',
  'ADA-alt',
  'ADA',
  'ADC-alt',
  'ADC',
  'ADX',
  'AE',
  'AEON-alt',
  'AEON',
  'AGI',
  'AGRS',
  'AION',
  'AMB',
  'AMP-alt',
  'AMP',
  'ANC-alt',
  'ANC',
  'ANT',
  'APEX',
  'APPC',
  'ARCH-alt',
  'ARCH',
  'ARDR-alt',
  'ARDR',
  'ARG',
  'ARK-alt',
  'ARK',
  'ARN',
  'ARY',
  'AST',
  'ATL',
  'ATM',
  'AUR-alt',
  'AUR',
  'AUTO',
  'BANX-alt',
  'BANX',
  'BAT-alt',
  'BAT',
  'BAY-alt',
  'BAY',
  'BBO',
  'BC-alt',
  'BC',
  'BCBC',
  'BCC',
  'BCD',
  'BCH-alt',
  'BCH',
  'BCN-alt',
  'BCN',
  'BCO',
  'BCPT',
  'BCY',
  'BDL',
  'BELA',
  'BETR',
  'BFT-alt',
  'BFT',
  'BIX',
  'BKX',
  'BLCN',
  'BLK',
  'BLOCK',
  'BLZ',
  'BNB',
  'BNT',
  'BNTY',
  'BOS',
  'BPT',
  'BQ',
  'BQX',
  'BRD',
  'BRK-alt',
  'BRK',
  'BRX-alt',
  'BRX',
  'BSD-alt',
  'BSD',
  'BTA',
  'BTC-alt',
  'BTC',
  'BTCD-alt',
  'BTCD',
  'BTCP-alt',
  'BTCP',
  'BTCZ',
  'BTDX',
  'BTG',
  'BTM-alt',
  'BTM',
  'BTS-alt',
  'BTS',
  'BTX',
  'BURST',
  'CALL',
  'CDN',
  'CDT',
  'CENZ',
  'CFI',
  'CHAT',
  'CHF',
  'CHIPS',
  'CIX',
  'CL',
  'CLAM-alt',
  'CLAM',
  'CLOAK-alt',
  'CLOAK',
  'CMM',
  'CMT',
  'CND',
  'CNX',
  'CNY',
  'COB',
  'COLX',
  'COQUI',
  'CRED',
  'CRPT',
  'CRW',
  'CS',
  'CTR',
  'CTXC',
  'CVC-alt',
  'CVC',
  'DAI',
  'DAO-alt',
  'DAO',
  'DAR',
  'DASH-alt',
  'DASH',
  'DAT',
  'DATA',
  'DBC',
  'DCN',
  'DCR-alt',
  'DCR',
  'DCT-alt',
  'DCT',
  'DEEZ',
  'DENT',
  'DEW',
  'DGB-alt',
  'DGB',
  'DGD',
  'DGX',
  'DHT',
  'DLT',
  'DMD-alt',
  'DMD',
  'DNR',
  'DNT',
  'DOCK',
  'DOGE-alt',
  'DOGE',
  'DRGN',
  'DROP',
  'DSH',
  'DTA',
  'DTR',
  'EBST',
  'ECA',
  'EDG',
  'EDO',
  'EDOGE',
  'ELA',
  'ELF',
  'ELIX',
  'ELLA',
  'EMC-alt',
  'EMC',
  'EMC2-alt',
  'EMC2',
  'ENG',
  'ENJ',
  'EOS-alt',
  'EOS',
  'EQLI',
  'EQUA',
  'ERC-alt',
  'ERC',
  'ETC-alt',
  'ETC',
  'ETH-alt',
  'ETH',
  'ETHOS',
  'ETN',
  'ETP',
  'EUR',
  'EURS',
  'EVX',
  'EXMO',
  'EXP-alt',
  'EXP',
  'FAIR',
  'FC2-alt',
  'FC2',
  'FCN',
  'FCT-alt',
  'FCT',
  'FIL',
  'FJC',
  'FLDC-alt',
  'FLDC',
  'FLO-alt',
  'FLO',
  'FRK-alt',
  'FRK',
  'FSN',
  'FTC-alt',
  'FTC',
  'FUEL',
  'FUN',
  'GAME-alt',
  'GAME',
  'GAS',
  'GBG',
  'GBP',
  'GBX',
  'GBYTE-alt',
  'GBYTE',
  'GDC-alt',
  'GDC',
  'GEMZ-alt',
  'GEMZ',
  'GENERIC',
  'GLD-alt',
  'GLD',
  'GMR',
  'GNO-alt',
  'GNO',
  'GNT-alt',
  'GNT',
  'GOLOS-alt',
  'GOLOS',
  'GRC-alt',
  'GRC',
  'GRS',
  'GSC',
  'GTO',
  'GUP',
  'GUSD',
  'GVT',
  'GXLT',
  'GXS',
  'GZR',
  'HEAT-alt',
  'HEAT',
  'HIGHT',
  'HMQ',
  'HODL',
  'HPB',
  'HSR',
  'HT',
  'HTML',
  'HUC-alt',
  'HUC',
  'HUSH',
  'ICN-alt',
  'ICN',
  'ICX',
  'IFC-alt',
  'IFC',
  'IGNIS',
  'INCNT-alt',
  'INCNT',
  'INK',
  'INS',
  'IOC-alt',
  'IOC',
  'ION',
  'IOP',
  'IOST',
  'IOTA-alt',
  'IOTA',
  'IOTX',
  'ITC',
  'JBS-alt',
  'JBS',
  'JNT',
  'JPY',
  'KCS',
  'KIN',
  'KMD-alt',
  'KMD',
  'KNC',
  'KOBO',
  'KORE-alt',
  'KORE',
  'KRB',
  'LBC-alt',
  'LBC',
  'LDOGE-alt',
  'LDOGE',
  'LEND',
  'LINK',
  'LKK',
  'LOOM',
  'LRC',
  'LSK-alt',
  'LSK',
  'LTC-alt',
  'LTC',
  'LUN',
  'MAID-alt',
  'MAID',
  'MANA',
  'MARKS-alt',
  'MARKS',
  'MCAP',
  'MCO-alt',
  'MCO',
  'MDA',
  'MDS',
  'MED',
  'MINT-alt',
  'MINT',
  'MIOTA',
  'MITH',
  'MKR',
  'MLN',
  'MNX',
  'MNZ',
  'MOAC',
  'MOD',
  'MONA-alt',
  'MONA',
  'MRC',
  'MSC-alt',
  'MSC',
  'MSR',
  'MTH',
  'MTL-alt',
  'MTL',
  'MTR-alt',
  'MTR',
  'MUE-alt',
  'MUE',
  'MUSIC',
  'MYST-alt',
  'MYST',
  'MZC',
  'NANO',
  'NAS',
  'NAV-alt',
  'NAV',
  'NBT',
  'NCASH',
  'NDZ',
  'NEBL',
  'NEO-alt',
  'NEO',
  'NEOS-alt',
  'NEOS',
  'NEU-alt',
  'NEU',
  'NEXO',
  'NGC',
  'NIO',
  'NLC2',
  'NLG-alt',
  'NLG',
  'NMC-alt',
  'NMC',
  'NMR',
  'NOAH',
  'NOTE-alt',
  'NOTE',
  'NPXS',
  'NULS',
  'NVC-alt',
  'NVC',
  'NXS',
  'NXT-alt',
  'NXT',
  'OAX',
  'OK-alt',
  'OK',
  'OMG-alt',
  'OMG',
  'OMNI-alt',
  'OMNI',
  'ONT',
  'OOT',
  'OPAL-alt',
  'OPAL',
  'OST',
  'OX',
  'PART-alt',
  'PART',
  'PASC',
  'PASL',
  'PAT',
  'PAY',
  'PAYX',
  'PIGGY-alt',
  'PIGGY',
  'PINK-alt',
  'PINK',
  'PIRL',
  'PIVX-alt',
  'PIVX',
  'PLR',
  'POA',
  'POE',
  'POLY',
  'POT-alt',
  'POT',
  'POWR',
  'PPC-alt',
  'PPC',
  'PPP',
  'PPT',
  'PRL',
  'PROC',
  'PTOY',
  'PURA',
  'QASH',
  'QCN',
  'QIWI',
  'QLC',
  'QRK-alt',
  'QRK',
  'QRL',
  'QSP',
  'QTUM-alt',
  'QTUM',
  'R',
  'RADS-alt',
  'RADS',
  'RAP',
  'RBIES-alt',
  'RBIES',
  'RBT-alt',
  'RBT',
  'RBY-alt',
  'RBY',
  'RCN',
  'RDD-alt',
  'RDD',
  'RDN',
  'REP-alt',
  'REP',
  'REQ',
  'RHOC',
  'RIC-alt',
  'RIC',
  'RISE-alt',
  'RISE',
  'RLC',
  'ROP',
  'RPX',
  'RUB',
  'RVN',
  'SAFE',
  'SALT-alt',
  'SALT',
  'SAN',
  'SAR-alt',
  'SAR',
  'SBD',
  'SBERBANK',
  'SC',
  'SCOT-alt',
  'SCOT',
  'SDC-alt',
  'SDC',
  'SHIFT',
  'SIA-alt',
  'SIA',
  'SIB',
  'SJCX-alt',
  'SJCX',
  'SKIN',
  'SKY',
  'SLG-alt',
  'SLG',
  'SLR',
  'SLS-alt',
  'SLS',
  'SMART',
  'SNGLS',
  'SNM',
  'SNRG-alt',
  'SNRG',
  'SNT',
  'SOC',
  'SPANK',
  'SPHTX',
  'SRN',
  'START-alt',
  'START',
  'STEEM-alt',
  'STEEM',
  'STORJ',
  'STORM',
  'STQ',
  'STRAT-alt',
  'STRAT',
  'STX',
  'SUB',
  'SUMO',
  'SWIFT-alt',
  'SWIFT',
  'SWT',
  'SYNC-alt',
  'SYNC',
  'SYS-alt',
  'SYS',
  'TAAS',
  'TAU',
  'TEL',
  'TEN',
  'TERN',
  'THETA',
  'TIME',
  'TIX',
  'TKN',
  'TNB',
  'TNC',
  'TNT',
  'TRIG-alt',
  'TRIG',
  'TRST',
  'TRTL',
  'TRX',
  'TUSD',
  'TX-alt',
  'TX',
  'TZC',
  'UBQ-alt',
  'UBQ',
  'UNITY-alt',
  'UNITY',
  'USD',
  'USDC',
  'USDT-alt',
  'USDT',
  'USNBT',
  'UTK',
  'VEN',
  'VERI',
  'VIA-alt',
  'VIA',
  'VIB',
  'VIBE',
  'VIOR-alt',
  'VIOR',
  'VIVO',
  'VNL-alt',
  'VNL',
  'VPN-alt',
  'VPN',
  'VRC-alt',
  'VRC',
  'VRSC',
  'VTC-alt',
  'VTC',
  'WABI',
  'WAN',
  'WAVES-alt',
  'WAVES',
  'WAX',
  'WGR',
  'WICC',
  'WINGS',
  'WPR',
  'WTC',
  'XAI-alt',
  'XAI',
  'XAS',
  'XAUR',
  'XBC',
  'XBS-alt',
  'XBS',
  'XBY',
  'XCP-alt',
  'XCP',
  'XDN',
  'XEM-alt',
  'XEM',
  'XIN',
  'XLM-alt',
  'XLM',
  'XMG',
  'XMO',
  'XMR',
  'XMY',
  'XP',
  'XPA',
  'XPM-alt',
  'XPM',
  'XRP-alt',
  'XRP',
  'XSG',
  'XTZ-alt',
  'XTZ',
  'XUC',
  'XVC-alt',
  'XVC',
  'XVG-alt',
  'XVG',
  'XZC-alt',
  'XZC',
  'YBC-alt',
  'YBC',
  'YOYOW',
  'ZAP',
  'ZCL',
  'ZEC-alt',
  'ZEC',
  'ZEIT-alt',
  'ZEIT',
  'ZEL',
  'ZEN',
  'ZIL',
  'ZILLA',
  'ZRX-alt',
  'ZRX'
];

export default haveIcon;
